<location-selector>
  <a
    class="x"
    href="#"
    onclick={event => onClose(event)}
  >
    schließen
    <dfk-icon type="cross" width="20px" height="20px"></dfk-icon>
    <div is="fixed-relative"></div>
  </a>

  <h2>Orte</h2>

  <div class="mb-4">
    <div is="foldout">
      <div is="dfk-raw" html={t('widget_location')} class="text-justify" />
    </div>
  </div>

  <dfk-input
    name="terms"
    update-handler={event => onSearch(event)}
    placeholder={t('search')}
  />

  <div class="row">
    <div class="col-8">
      <div class="map" />
    </div>

    <div class="col-4 pl-3">
      <h3>Bezirke</h3>

      <div class="region-selector">
        <ul class="list-unstyled">
          <li each={region in regions()} class="mb-1">
            <a
              onclick={event => toggleRegion(region, event)}
              class={state.activeRegions[region] && 'active'}
            >{region}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <script>
    import * as L from 'leaflet'
    import {util} from '@wendig/lib'
    import search from '../lib/search.instance'
    import config from '../lib/dotenv'

    export default class {
      constructor() {
        this.onSearch = this.onSearch.bind(this)
        this.onSearch = util.delay(this.onSearch, 300)
      }

      onBeforeMount(props) {
        this.state['activeRegions'] = {}

        search.locations().then(data => {
          let regions = {}
          let bounds = {}

          for (const l of data.records) {
            regions[l.Bezirk] = true
            l.lng = parseFloat(l.GeoL)
            l.lat = parseFloat(l.GeoB)
          }

          regions = Object.keys(regions).sort()

          this.update({data, regions})
        })
      }

      onMounted() {
        const element = this.root.querySelector('.map')

        const map = L.map(element, {
          zoomControl: false,
          zoomSnap: 0,
          minZoom: 3,
          maxZoom: 12,
          attributionControl: false,
        }).setView([48.0, 10.0], 6)

        const bg = L.tileLayer(`https://tile.openstreetmap.de/{z}/{x}/{y}.png`, {
          maxZoom: 19,
          attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        })
        map.addLayer(bg)

        const pins = new L.FeatureGroup()
        map.addLayer(pins)

        this.state['map'] = map
        this.state['pins'] = pins
      }

      onBeforeUpdate(props, state) {
        state.activeLocations = {}

        const regions = {}

        for (const bucket of props.aggregation.buckets) {
          state.activeLocations[bucket.key] = bucket['doc_count']
        }

        state['regions'] = []

        if (this.state['data']) {
          let flags = {}
          for (const l of this.state['data']['records']) {
            if (state.activeLocations[l.Ortsname_vergl]) {
              flags[l.Bezirk] = true
            }
          }

          state['regions'] = Object.keys(flags).sort()
        }
      }

      onUpdated(props, state) {
        const map = state['map']
        const pins = state['pins']

        pins.clearLayers()

        for (const l of this.locations()) {
          const count = state.activeLocations[l.Ortsname_vergl] || 0

          let iconUrl = `${config.STATIC_URL}/images/marker-icon.png`
          let zIndexOffset = 100
          let text = `${l.Ortsname_vergl} (${count})`
          if (!count) {
            continue
            
            // iconUrl = `${config.STATIC_URL}/images/marker-icon.inactive.png`
            // zIndexOffset = 0
            // text = l.Ortsname_vergl
          }

          const marker = L.marker([l.lat, l.lng], {
            icon: L.icon({iconUrl}),
            zIndexOffset
          }).
          bindTooltip(text)
          marker.on('click', event => this.props.addFilter({location: l.Ortsname_vergl}))
          // marker.on('mouseover', event => console.log(event))
          // marker.on('mouseout', event => console.log(event))
          pins.addLayer(marker)
        }

        this.flyToBounds()
      }

      onSearch(values) {
        this.update({filter: values['terms']})
      }

      flyToBounds() {
        const map = this.state['map']
        const pins = this.state['pins']

        const pinCount = Object.values(pins._layers).length
        if (pinCount > 0) {
          const bounds = pins.getBounds().pad(0.2)
          // temporarily restrict max zoom so that flying in on a single marker
          // doesn't zoom in to street level
          const max = map.getMaxZoom()
          map.setMaxZoom(10)
          map.flyToBounds(bounds, {duration: 0.3})
          map.setMaxZoom(max)
        }
      }

      toggleRegion(region, event) {
        event.preventDefault()
        const active = this.state.activeRegions

        if (active[region]) {
          delete active[region]
        } else {
          this.state.activeRegions = {[region]: true}
        }

        this.update()
      }

      regions() {
        return this.state['regions'] || []
      }

      locations() {
        if (!this.state.data) return []

        let results = this.state['data']['records']

        const regions = this.state.activeRegions
        if (Object.keys(regions).length) {
          results = results.filter(l => !!regions[l.Bezirk])
        }

        let filter = this.state['filter']
        if (filter) {
          filter = util.fold(filter)
          results = results.filter(l => {
            const r = new RegExp(filter)
            const v = util.fold(l.Ortsname_vergl)
            return v.match(r)
          })
        }

        return results
      }

      onClose(event) {
        event.preventDefault()

        this.props.onClose(event)
      }
    }
  </script>
</location-selector>
